import Vue from 'vue'
import VueRouter from 'vue-router'
import VueMeta from 'vue-meta'
import Home from '../views/Landing.vue'
import { installAnalytics } from '../plugins/analytics'
import store from '../store'
import { EVENT_BUS } from '../utils'

Vue.use(VueRouter)
Vue.use(VueMeta)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/admin/signup',
    name: 'signup',
    component: () => import(/* webpackChunkName: "signup" */ '../views/account/Signup.vue')
  },
  {
    path: '/auth/signup/invite/:token',
    name: 'signup_invite',
    props: true,
    component: () => import(/* webpackChunkName: "signup-invite" */ '../views/account/SignupInvite.vue')
  },
  {
    path: '/signup/complete/:token',
    name: 'complete_signup',
    component: () => import(/* webpackChunkName: "complete-signup" */ '../views/account/CompleteSignup.vue')
  },
  {
    path: '/auth/verifyaccount/:token',
    name: 'verify_account',
    props: true,
    component: () => import(/* webpackChunkName: "account-verify" */ '../views/account/VerifyAccount.vue')
  },
  {
    path: '/admin/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '../views/account/Login.vue')
  },
  {
    path: '/account/forgotpassword',
    name: 'forgot_password',
    component: () => import(/* webpackChunkName: "forgot-password" */ '../views/account/ForgotPassword.vue')
  },
  {
    path: '/account/resetpassword/:token',
    name: 'reset_password',
    component: () => import(/* webpackChunkName: "reset-password" */ '../views/account/ResetPassword.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    meta: {
      layout: 'dashboard',
      isProtected: true
    },
    component: () => import(/* webpackChunkName: "dashboard" */ '../views/dashboard/index.vue')
  },
  {
    path: '/dashboard/prayerrequest',
    name: 'prayer_request',
    meta: {
      layout: 'dashboard',
      isProtected: true
    },
    component: () => import(/* webpackChunkName: "prayerrequest" */ '../views/dashboard/prayerrequest.vue')
  },
  {
    path: '/dashboard/manageusers',
    name: 'manage_users',
    meta: {
      layout: 'dashboard',
      isProtected: true
    },
    component: () => import(/* webpackChunkName: "manageusers" */ '../views/dashboard/manageusers.vue')
  },
  {
    path: '/dashboard/managecategories',
    name: 'manage_categories',
    meta: {
      layout: 'dashboard',
      isProtected: true
    },
    component: () => import(/* webpackChunkName: "manageusers" */ '../views/dashboard/managecategories.vue')
  },
  {
    path: '/dashboard/testimonies',
    name: 'testimonies',
    meta: {
      layout: 'dashboard',
      isProtected: true
    },
    component: () => import(/* webpackChunkName: "manageusers" */ '../views/dashboard/testimonies.vue')
  },
  {
    path: '/dashboard/testimony',
    name: 'testimony',
    meta: {
      layout: 'dashboard',
      isProtected: true
    },
    component: () => import(/* webpackChunkName: "manageusers" */ '../views/dashboard/testimony.vue')
  },
  {
    path: '/account/profile',
    name: 'profile',
    meta: {
      isProtected: true
    },
    component: () => import(/* webpackChunkName: "profile" */ '../views/account/Profile.vue')
  },
  {
    path: '/account/changepassword',
    name: 'change_password',
    meta: {
      isProtected: true
    },
    component: () => import(/* webpackChunkName: "changepassword" */ '../views/account/ChangePassword.vue')
  },
  {
    path: '/documents/data-privacy-protection-act',
    name: 'dppa',
    meta: {
      layout: 'docs'
    },
    component: () => import(/* webpackChunkName: "data-privacy-protection-act" */ '../docs/data-privacy-protection-act.mdx')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(async (to, _from, next) => {
  if (!to.meta.isProtected) next()
  else {
    if (!store.getters['auth/isAuthenticated']) {
      const userId = store.getters['auth/userId']
      const authToken = store.getters['auth/authToken']
      if (!!userId && !!authToken) {
        await store.dispatch('users/getUserById', userId)
        next()
      } else {
        router.push('/admin/login')
      }
    } else {
      next()
    }
  }
})

EVENT_BUS.$on('token:expired', () => {
  router.push('/admin/login')
})

// Install analytics
installAnalytics({ router })

export default router
